const items = [
  'Halal Certified',
  'Grass-fed Beef',
  'Free-range Poultry',
  'Organic Sourcing',
  'House-cured Smallgoods',
  'Cold-chain Delivered',
  'Made in Malaga, WA',
  'Est 2001',
];

export default function Marquee() {
  return (
    <div className="border-b border-white/10 bg-[var(--mw-primary)] py-3" data-testid="top-marquee-wrapper">
      <div className="mw-marquee" data-testid="marquee">
        {[0, 1].map((k) => (
          <div key={k} className="mw-marquee__track" aria-hidden={k === 1}>
            {items.concat(items).map((it, i) => (
              <span
                key={`${k}-${i}`}
                className="flex items-center gap-12 text-[11px] sm:text-xs uppercase tracking-[0.32em] text-white"
              >
                {it}
                <span className="block w-1 h-1 rounded-full bg-white/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
